// extracted by mini-css-extract-plugin
export var card = "ring-slider-module--card--VaO0s";
export var container = "ring-slider-module--container--hafWe";
export var heading = "ring-slider-module--heading--WSCAm";
export var slide = "ring-slider-module--slide--fn1lP";
export var slider = "ring-slider-module--slider--P58KC";